import Component from '../../colorz/Component';

export default class TrackingForm extends Component {
	/**
	 * Initialise.
	 */
	onInit(el) {
		this.form = el;
	}

	onLoad() {
		this.form.addEventListener('submit', (event) => {
			this.handleFormSubmit(event);
		});
	}

	/**
	 * Handle form submit event.
	 */
	handleFormSubmit(event) {
		if (this.form.getAttribute('id') === 'customer_login') {
			const dataLayerLogin = {
				event: 'login',
				method: 'email',
			};
			window.dataLayer.push(dataLayerLogin);
		} else if (this.form.getAttribute('id') === 'create_customer') {
			const dataLayerRegister = {
				event: 'sign_in',
				method: 'email',
			};
			window.dataLayer.push(dataLayerRegister);
		} else if (this.form.getAttribute('id') === 'contact_form') {
			const dataLayerRegister = {
				event: 'newsletter_subscribe',
			};
			window.dataLayer.push(dataLayerRegister);
		}
	}
}
